import type {Appareil} from "@mytour/shared";
import {FloatingField} from "@mytour/ui/form";
import {Splitter} from "@mytour/ui/layout";
import type {Control, FieldErrors} from "react-hook-form";
import {z} from "zod";

export const applianceDetailsSchema = z.object({
  appareilMarque: z.string().optional(),
  appareilModele: z.string().optional(),
  appareilPuissance: z.string().optional(),
  appareilNumeroSerie: z.string().optional(),
  appareilDateInstallation: z.string().optional(),
  appareilGarantie: z.string().optional(),
});

export type ApplianceDetailsFormData = z.infer<typeof applianceDetailsSchema>;

type Props = {
  control: Control<ApplianceDetailsFormData>;
  errors: FieldErrors<ApplianceDetailsFormData>;
  disabled: boolean;
};

export function ApplianceDetailsForm({control, errors, disabled}: Props) {
  return (
    <>
      <h5 style={{marginBottom: "16px"}}>Détails appareil</h5>
      <p style={{fontSize: "14px", color: "#666", marginBottom: "16px"}}>
        Tous les champs sont optionnels.
      </p>

      <Splitter>
        <FloatingField
          name="appareilMarque"
          label="Marque"
          control={control}
          error={errors.appareilMarque}
          disabled={disabled}
        />
        <FloatingField
          name="appareilModele"
          label="Modèle"
          control={control}
          error={errors.appareilModele}
          disabled={disabled}
        />
      </Splitter>

      <Splitter>
        <FloatingField
          name="appareilPuissance"
          label="Puissance (kW)"
          control={control}
          error={errors.appareilPuissance}
          disabled={disabled}
        />
        <FloatingField
          name="appareilNumeroSerie"
          label="N° de série"
          control={control}
          error={errors.appareilNumeroSerie}
          disabled={disabled}
        />
      </Splitter>

      <Splitter>
        <FloatingField
          name="appareilDateInstallation"
          label="Date d'installation"
          control={control}
          error={errors.appareilDateInstallation}
          disabled={disabled}
        />
        <FloatingField
          name="appareilGarantie"
          label="Garantie"
          control={control}
          error={errors.appareilGarantie}
          disabled={disabled}
        />
      </Splitter>
    </>
  );
}

export function getApplianceDetailsDefaultValues(appareil: Appareil): ApplianceDetailsFormData {
  return {
    appareilMarque: appareil.appareilMarque ?? "",
    appareilModele: appareil.appareilModele ?? "",
    appareilPuissance: appareil.appareilPuissance ?? "",
    appareilNumeroSerie: appareil.appareilNumeroSerie ?? "",
    appareilDateInstallation: appareil.appareilDateInstallation ?? "",
    appareilGarantie: appareil.appareilGarantie ?? "",
  };
}
